<script>
import Modal from './modal.vue'
import { mapState } from 'pinia'
import get from 'lodash/get'
import { useQuestionsStore } from '~/store/questions'
import { useBusinessSwitchStore } from '~/store/business-switch'

export default {
  name: 'WarningModal',
  components: {
    Modal
  },
  computed: {
    ...mapState(useBusinessSwitchStore, {
      warningModalVisible: (store) => get(store, 'warningModalVisible')
    })
  },
  methods: {
    async closeWarningModal() {
        useBusinessSwitchStore(this.$pinia).warningModalToggle(false)
      },
    async discardAndSwitch() {
      await useQuestionsStore(this.$pinia).clearStateAnswers()
      useBusinessSwitchStore(this.$pinia).businessSwitchModalToggle(true)
    }
  },
  setup() {
    function modalStyles() {
      return {
        'modal-wrapper': {
          'transform': 'translateY(70%)'
        },
      }
    }

    return {
      modalStyles
    }
  }
}
</script>

<template>
  <section>
    <Modal
      :showModal="warningModalVisible"
      :customFooter="true"
      size="modal-md"
      @close="closeWarningModal"
      class="text-start"
      :optionalStyles="modalStyles()"
    >
    <template #header>
      <span class="mb-3 text-left d-block">
        You have unsaved changes
      </span>
    </template>
    <template #body>
      <div class="text-left mt-4">
        <p>Switching will discard all unsaved changes on this page.</p>
        <p class="mt-5">To save your changes, return to the application and proceed to the next page.</p>
        <div class="modal-footer">
          <a href="javascript:" style="margin-right: 20px;" @click="closeWarningModal">Cancel</a>
          <button type="button" @click="discardAndSwitch" class="btn btn-danger">Discard and Switch</button>
        </div>
      </div>
    </template>
    </Modal>
  </section>
</template>

<style scoped lang="scss">
@import 'lendio-modals';
</style>
